import { Component, Input } from '@angular/core';
import {
    StreamerServicesComponent
} from "@cybfed/new-ui/components/top-popular-widgets/streamer-services/streamer-services.component";
import {MainStoreService} from "@cybfed/core/store/main.store.service";

@Component({
    selector: 'app-store-preview',
    standalone: true,
    imports: [
        StreamerServicesComponent
    ],
    providers: [
    ],
    templateUrl: './store-preview.component.html'
})
export class StorePreviewComponent {
    @Input() componentModel?: any;
    constructor(public mainStore: MainStoreService) {
    }

}
